export interface InstantSearchFilterExplanationProps {
  explanation: string | string[];
}

const InstantSearchFilterExplanation = ({
  explanation,
}: InstantSearchFilterExplanationProps) => (
  <div className="ch-bg--white ch-ph--2 ch-pt--1 ch-pb--0 ch-ba--1 ch-bc--grey-1 ch-rounded--md ch-mv--4">
    {Array.isArray(explanation) ? (
      explanation.map((text, index) => (
        <p key={`explanation-${index}`}>{text}</p>
      ))
    ) : (
      <p>{explanation}</p>
    )}
  </div>
);

export default InstantSearchFilterExplanation;
